import { render, staticRenderFns } from "./AuthorForm.vue?vue&type=template&id=d5711372&scoped=true"
import script from "./AuthorForm.vue?vue&type=script&lang=js"
export * from "./AuthorForm.vue?vue&type=script&lang=js"
import style0 from "./AuthorForm.vue?vue&type=style&index=0&id=d5711372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5711372",
  null
  
)

export default component.exports